import { render, staticRenderFns } from "./CreditModal.vue?vue&type=template&id=37fcb6dc"
import script from "./CreditModal.vue?vue&type=script&lang=js"
export * from "./CreditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports